import type { InsuranceIndex } from '../../../types/InsuranceFeatureConfig';
import type { TravelFeatureConfig } from '../../../types/insurances/TravelFeatureConfig';
import { travel as base } from './base';
import { travel as AT } from './AT';
import { travel as CZ } from './CZ';
import { travel as HR } from './HR';
import { travel as HU } from './HU';
import { travel as RO } from './RO';
import { travel as SK } from './SK';

export const travelConfig: InsuranceIndex<TravelFeatureConfig> = { base, AT, CZ, HR, HU, RO, SK };
